import React, { useState, useEffect } from 'react';
import { useLocation, } from 'react-router-dom';
import Header from './Header'
import Scrollcard from './Scrollcard';
import Products from './Products';
import Feedback from './Feedback';
// import CartPage from './CartPage';
const HomePage = () => {

  const [cart, setCart] = useState([]);

  const cartHandle = (id) => {
    const newCart = [...cart];
    const index = newCart.indexOf(id);
    if (index > -1) {
        newCart.splice(index, 1);
    } else {
        newCart.push(id);
    }
    setCart(newCart);
};

const location = useLocation();
const initialData = location.state;
const [data, setData] = useState(initialData);
useEffect(()=>{
  if (data) {
    setCart(data);
  }
},[data])




  return (
    <div className='bg-white' style={{height:100+'vh', overflowY:'scroll', overflowX:'hidden'}}>
        <Header cart={cart}/>
        <Scrollcard/>
        <Products cartHandle={cartHandle} cart={cart} />
      <Feedback/>
        </div>
  )
}

export default HomePage